import React, { memo, useCallback, useState } from 'react';

import { InfoBlock } from '@picsio/ui';

import localization from '../../../../shared/strings';
import { LocalStorage } from '../../../../shared/utils';
import styles from './AggregatedBulkAttributesNote.module.scss';

const STORAGE_KEY = 'picsio.aggregatedBulkAttributesNoteDismissed';
const l10n = localization.PRODUCT_INFO.aggregated;

const AggregatedBulkAttributesNote = () => {
  const [isDismissed, setDismissed] = useState(() => Boolean(LocalStorage.get(STORAGE_KEY)));

  const onClose = useCallback(() => {
    LocalStorage.set(STORAGE_KEY, true);
    setDismissed(true);
  }, []);

  if (isDismissed) return null;

  return (
    <InfoBlock
      className={styles.note}
      maxWidth="100%"
      data-qa="aggregatedBulkAttributesNote"
      onClose={onClose}
    >
      {l10n.bulkAttributesMasterOnlyNote}
    </InfoBlock>
  );
};

export default memo(AggregatedBulkAttributesNote);
